import React from 'react';

import ClockSvg from 'assets/images/clock-icon.svg';

import BaseIcon from './BaseIcon';

const ClockIcon = props => (
  <BaseIcon {...props} src={ClockSvg} />
);

export default ClockIcon;
